{
  "basePath": "assets/help/",
  "fileName": "CI-MAN-001-100.pdf"
}